import { InputTextRow } from "@components";
import { Button, SectionHeader } from "@pentabd/ui";
import { emailFormat } from "@validations/HRM/employee/generalInfoValidation";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

export const ChangeEmail = ({ email }: { email: string | undefined }) => {
  const { t } = useTranslation();

  const {
    formState: { errors },
    register,
  } = useFormContext();

  return (
    <div>
      <SectionHeader
        title={t("HRM_SETTINGS.EMAIL_UPDATE.CHANGE_EMAIL.HEADER")}
      />

      <div className="p-10 d-flex flex-column gap-8">
        <InputTextRow
          register={register("previousEmail")}
          label="HRM_SETTINGS.EMAIL_UPDATE.CHANGE_EMAIL.FORM.FIELDS.OLD_EMAIL"
          value={email}
          disabled
          controlling
        />
        <InputTextRow
          register={register("newEmail", {
            required: {
              value: true,
              message: t(
                "HRM_SETTINGS.EMAIL_UPDATE.CHANGE_EMAIL.FORM.FIELDS.NEW_EMAIL.ERRORS.REQUIRED",
              ),
            },
            pattern: {
              value: emailFormat,
              message: t(
                "HRM_SETTINGS.EMAIL_UPDATE.CHANGE_EMAIL.FORM.FIELDS.NEW_EMAIL.ERRORS.INVALID_EMAIL",
              ),
            },
          })}
          label="HRM_SETTINGS.EMAIL_UPDATE.CHANGE_EMAIL.FORM.FIELDS.NEW_EMAIL"
          error={errors}
        />
        <div className="row border-top pt-8">
          <div className="col-12 d-flex justify-content-end gap-6">
            <Button fill="fill" size="sm" type="primary" htmlType="submit">
              {t(
                "HRM_SETTINGS.EMAIL_UPDATE.CHANGE_EMAIL.FORM.BUTTONS.UPDATE_BUTTON",
              )}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
